///
/// EarthBrowser
///
/// Migration v22 to v23: Add city_weather dataset type support
///
/// This migration ensures the visibleDatasets array can include "city_weather"
/// and validates any existing dataset arrays.
///
/// Created by Matt Giger on 1/4/2026
/// Copyright (c) 2026 Geodata Labs
///

interface StateV22 {
	earthbrowser?: {
		visibleDatasets?: string[]
	}
}

/**
 * Migration from version 22 to 23: Add city_weather dataset support
 * - Validates visibleDatasets array to ensure it can include "city_weather"
 *
 * Note: Redux freezes state objects, so we must return a new object rather than mutate
 */
export function migrateV22toV23(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV22
	const oldEarthbrowser = s.earthbrowser || {}

	// Ensure visibleDatasets is a valid array
	const visibleDatasets = Array.isArray(oldEarthbrowser.visibleDatasets)
		? [...oldEarthbrowser.visibleDatasets]
		: ["cloud", "earthquake", "satellite", "aurora", "volcano"]

	// Filter out any invalid dataset types that might have crept in
	// city_weather is now valid
	const validDatasets = visibleDatasets.filter((d: string) =>
		["satellite", "airport", "buoy", "city_weather", "earthquake", "volcano",
		 "location", "cloud", "stars", "aurora", "wildfire",
		 "weather", "package", "devtools", "nexrad", ""].includes(d)
	)

	// Create new earthbrowser state
	const newEarthbrowser = {
		...oldEarthbrowser,
		visibleDatasets: validDatasets,
	}

	// Return completely new state object
	return {
		...s,
		earthbrowser: newEarthbrowser
	}
}
